import { useState, useEffect } from 'react';
import { makeGetCall } from '../utils/helper';

/**
 * Custom hook to fetch and cache modality options
 * @returns {Object} { modalityOptions, loading, error, refetch }
 */
export const useModalities = () => {
  const [modalityOptions, setModalityOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchModalities = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await makeGetCall('/modalities');
      
      if (response?.data?.success) {
        setModalityOptions(response.data.data || []);
      } else {
        throw new Error(response?.data?.message || 'Failed to fetch modalities');
      }
    } catch (err) {
      console.error('Error fetching modalities:', err);
      setError(err.message || 'Failed to fetch modalities');
      
      // Fallback to hardcoded options if API fails (aligned with your data)
      setModalityOptions([
        { label: 'CT', value: 'CT' },
        { label: 'US', value: 'US' },
        { label: 'MR', value: 'MR' },
        { label: 'DX', value: 'DX' }
      ]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchModalities();
  }, []);

  const refetch = () => {
    fetchModalities();
  };

  return {
    modalityOptions,
    loading,
    error,
    refetch
  };
};